import { useMapsLibrary } from "@vis.gl/react-google-maps";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import "./styles.css";
//https://visgl.github.io/react-google-maps/examples/drawing
const SearchControl = ({ onPlaceSelect }) => {
    const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
    const places = useMapsLibrary('places');
    const inputRef = useRef(null);
    useEffect(() => {
        if (!places || !inputRef.current)
            return;
        const options = {
            fields: ["geometry", "name", "formatted_address"]
        };
        setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
    }, [places]);
    useEffect(() => {
        if (!placeAutocomplete)
            return;
        placeAutocomplete.addListener('place_changed', () => {
            //console.log(placeAutocomplete.getPlace())
            onPlaceSelect(placeAutocomplete.getPlace());
        });
    }, [onPlaceSelect, placeAutocomplete]);
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            const input = inputRef.current;
            if (!input)
                return;
            const hasSelectedItem = document.querySelector(".pac-item-selected");
            if (hasSelectedItem)
                return; //let Google handle it
            e.preventDefault();
            const rawValue = input.value.trim();
            if (!rawValue)
                return;
            const autocompleteService = new google.maps.places.AutocompleteService();
            autocompleteService.getPlacePredictions({ input: rawValue }, (predictions, status) => {
                console.log(predictions);
                if (!predictions)
                    return;
                if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions.length)
                    return;
                const first = predictions[0];
                const placesService = new google.maps.places.PlacesService(document.createElement("div"));
                placesService.getDetails({ placeId: first.place_id }, (place, status) => {
                    if (status !== google.maps.places.PlacesServiceStatus.OK)
                        return;
                    if (!place)
                        return;
                    onPlaceSelect(place);
                });
            });
        }
    };
    return (
    //<MapControl position={ControlPosition.TOP_LEFT}>
    React.createElement("div", { className: "autocomplete-container" },
        React.createElement("input", { className: "form-control", ref: inputRef, onKeyDown: handleKeyDown }))
    //</MapControl>
    );
};
export default SearchControl;
